<ng-template #publicationEditTemplateRef>
  <h1 mat-dialog-title [translate]="title"></h1>

  <div mat-dialog-content>
    <form [formGroup]="form">
      <mat-card>
        <mat-card-title translate="publications/edition/publish-on-account"></mat-card-title>
        <p *ngIf="publicationToEdit?.status === 'scheduled'">
          <span translate="publications/schedule/current-date"></span> :
          <span>{{ publicationToEdit?.last_revision.publication_time | dateTimezone: 'longDate' }}</span
          >,
          <span>{{ publicationToEdit?.last_revision.publication_time | dateTimezone: 'shortTime' }}</span>
        </p>

        <p *ngIf="isTwitter">
          <span translate="publications/edition/twitter-only-one-account"></span><br />
          <a
            href="https://blog.twitter.com/developer/en_us/topics/tips/2018/automation-and-the-use-of-multiple-accounts.html"
            target="_blank"
            >https://blog.twitter.com/developer/en_us/topics/tips/2018/automation-and-the-use-of-multiple-accounts.html</a
          >
        </p>

        <app-select [control]="form.get('site')" [items]="sites" labelKey="publications/list/account_name"></app-select>
      </mat-card>
      <mat-card>
        <mat-card-title translate="publications/edition/text"></mat-card-title>

        <div>
          <span *ngIf="isTwitter" translate="publications/edition/enter-text/twitter"></span>
          <span *ngIf="isFacebook" translate="publications/edition/enter-text/facebook"></span>
        </div>

        <div>
          <span *ngIf="parentPublication && parentPublication.sent[0].url">
            {{ 'publications/edition/reply-to' | translate }}
            <a href="{{ parentPublication.sent[0].url }}" target="_blank">{{ parentPublication.sent[0].url }}</a>
          </span>
        </div>

        <app-message-editor-wrapper
          *ngIf="selectedSite"
          [control]="form.get('editors')"
          [editorInitialContent]="editorInitialContent"
          [isPublish]="true"
          [site]="selectedSite">
        </app-message-editor-wrapper>

        <div *ngIf="isFacebook && !hasAttachements">
          <div translate="publications/edition/link" class="subtitle"></div>
          <div translate="publications/edition/enter-link"></div>

          <mat-form-field>
            <input matInput formControlName="attachedLink" />
          </mat-form-field>
        </div>

        <div *ngIf="isTwitter && imgAltTextFormArray.length > 0">
          <div translate="publication/edition/images-alt" class="subtitle"></div>
          <div translate="publication/edition/images-alt/explain"></div>

          <ng-container formArrayName="imgAltTextFormArray">
            <div *ngFor="let group of imgAltTextFormArray.controls; let i = index">
              <div [formGroupName]="i" class="alt-text">
                <img [appJwtSrc]="attachmentBaseUrl + group.value.id" />
                <mat-form-field>
                  <input matInput formControlName="altText" />
                </mat-form-field>
              </div>
            </div>
          </ng-container>
        </div>
      </mat-card>

      <mat-card>
        <mat-card-title translate="publication/edition/internal-note"> </mat-card-title>
        <mat-form-field>
          <mat-label translate="publication/edition/internal-note/explain"></mat-label>
          <textarea matInput formControlName="internalNote"></textarea>
        </mat-form-field>
      </mat-card>
    </form>
  </div>

  <div mat-dialog-actions>
    <button type="button" mat-raised-button (click)="cancel()" translate="cancel"></button>

    <!-- this button is not disabled if form is invalid, because RATP save drafts with texts too long for twitter, and use it as templates -->
    <button
      type="button"
      mat-raised-button
      *ngIf="!parentPublication"
      (click)="saveAsDraft()"
      translate="publication/edition/save-as-draft"></button>

    <button
      type="button"
      mat-raised-button
      color="primary"
      *ngIf="!parentPublication"
      (click)="schedule()"
      [disabled]="form.invalid">
      <span
        [translate]="
          publicationToEdit?.status === 'scheduled'
            ? 'publication/edition/schedule-edit'
            : 'publication/edition/schedule'
        "></span>
    </button>

    <button
      type="button"
      mat-raised-button
      color="primary"
      *ngIf="dummyTrue"
      (click)="publishNow(false)"
      [disabled]="form.invalid"
      translate="publication/edition/publish-now"></button>

    <button
      type="button"
      mat-raised-button
      color="primary"
      *ngIf="!parentPublication"
      (click)="publishNow(true)"
      [disabled]="form.invalid"
      translate="publication/edition/publish-and-duplicate"></button>
  </div>
</ng-template>

<app-date-time-schedule-modal
  *ngIf="displayDateTimeModal"
  (closeModal)="confirmSchedule($event)"
  [dateTime]="publicationToEdit?.status === 'scheduled' ? publicationToEdit?.last_revision.publication_time : null"
  [rangeValidation]="rangeValidation"
  confirmBtnTextKey="publication/edition/schedule"
  modalTitleKey="publications/schedule/title"></app-date-time-schedule-modal>
